// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order_icon {
  position: absolute;
  font-size: 1rem;
  right: 1.5rem;
  color: darkorange;
  padding: 0 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/simulation/simulation-set/simulation-set.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AACF","sourcesContent":[".order_icon {\r\n  position: absolute;\r\n  font-size: 1rem;\r\n  right: 1.5rem;\r\n  color: darkorange;\r\n  padding: 0 2px;\r\n  // top: 1.5rem;\r\n  // border: 2px solid darkorange;\r\n  // border-radius: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
